import { BrokeragePlanningToolPanel } from "../BrokeragePlanningToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCoveredBrokerageMovementTable extends Layout {
    layoutBrokeragePlanningToolPanel: BrokeragePlanningToolPanel;
    panelSecondaryFilters: Panel;
    sourceBrokerageMovements: DataSource;
    sourceMovement: DataSource;
    tableMovements: Table;
}
